import React from 'react'
import HomepageComp1 from '../../components/homepage-components/HomepageComp1'
import "./home.css"
import HomepageComp2 from '../../components/homepage-components/HomepageComp2'
import HomepageComp3 from '../../components/homepage-components/HomepageComp3'
import HomepageComp4 from '../../components/homepage-components/HomepageComp4'
import HomepageComp5 from '../../components/homepage-components/HomepageComp5'
import HomepageComp6 from '../../components/homepage-components/HomepageComp6'

const Home = () => {
  return (
    <div className='homepage-main-container'>
      <HomepageComp1/>
      <HomepageComp2/>
      <HomepageComp3/>
      <HomepageComp4/>
      <HomepageComp5/>
      {/* <HomepageComp6/> */}
    </div>
  )
}

export default Home